module.exports = __webpack_public_path__ + "static/media/poster_IndianBobber.9d798cca.png";